import { t } from "i18next";

import React from "react";

export const Back = (props: any): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            viewBox="0 0 350 87"
        >
            <g
                id="Groupe_5"
                data-name="Groupe 5"
                transform="translate(1555 185)"
            >
                <g
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    transform="translate(-1555 -185)"
                    fill="#5b5959"
                    stroke="#686868"
                    stroke-width="2"
                >
                    <rect height={props.height} rx="9" stroke="none" />
                    <rect
                        x="1"
                        y="1"
                        width="348"
                        height="85"
                        rx="8"
                        fill="none"
                    />
                </g>
                <text
                    id="Retour"
                    transform="translate(-1380 -127)"
                    fill="#060505"
                    font-size="38"
                    font-family="HelveticaNeue-Medium, Helvetica Neue"
                    font-weight="500"
                >
                    <tspan x="-59.128" y="0">
                        {" "}
                        {t("Back", { lng: props.selectedLanguage })}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};
